import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, s = /* @__PURE__ */ t("path", {
  fill: "#FCFCFC",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ t("path", {
  fill: "#6DA544",
  d: "M31.304 17.391h-2.608a8.696 8.696 0 0 1-17.392 0H8.697c0 5.173 3.475 9.535 8.217 10.878-.52.988-.44 2.232.302 3.159l2.843-2.279 2.843 2.278c.75-.936.824-2.195.286-3.188 4.691-1.376 8.117-5.711 8.117-10.848Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M13.043 16.522s0 4.348 4.348 4.348l.87.87H20s.87-2.61 2.609-2.61c0 0 0-1.739 1.739-1.739h2.608s-.87-3.478 3.479-6.087l-1.74-.87s-6.086 4.349-10.434 3.48v1.738h-1.74l-.869-.87-2.608 1.74Z"
}, null, -1), h = [
  s,
  n,
  c
];
function r(d, i) {
  return e(), l("svg", o, [...h]);
}
const a = { render: r };
export {
  a as default,
  r as render
};
